module.exports = __webpack_public_path__ + "media/vvv-dashboard-guide-es.bd72f793.mp4";